import IPropertyRecord = ZoningAPI.IPropertyRecord;
import IBuilding = ZoningAPI.IBuilding;

import { ClonableItem } from './clonable-item';
import { PropertyRecordCalculationStatus } from '../enums';
import * as _ from 'lodash';
import { Building } from './building';
import { DataSourceCategory } from '../enums/data-source-category';
import ICalculationResult = ZoningAPI.ICalculationResult;
import IZoneIQExtendedZoningCodeDTO = ZoningAPI.IZoneIQExtendedZoningCodeDTO;

export class PropertyRecord extends ClonableItem<IPropertyRecord> implements IPropertyRecord {
    Id: number;
    GridicsId: string;
    Address: string;
    Folio: string;
    GroupId: string;

    CalculationResults: ICalculationResult[] = [];
    Buildings: IBuilding[];
    CalculationStatus: PropertyRecordCalculationStatus;
    LastZoningCodeVersion?: number;
    DataSourceCategory?: DataSourceCategory;

    CalculationResult?: ICalculationResult;
    ZoningCode?: IZoneIQExtendedZoningCodeDTO;

    constructor(value?: IPropertyRecord) {
        super(value);
        this.initBuildings();
    }

    get hasBuildings() {
        return (
            this.CalculationStatus == PropertyRecordCalculationStatus.OK ||
            this.CalculationStatus == PropertyRecordCalculationStatus.WITH_NOTIFICATIONS
        );
    }

    get calculationResultsCount() {
        return _.get(this, 'CalculationResults.length', 0);
    }

    get hasCalculationResults() {
        return !!this.calculationResultsCount;
    }

    get isCalculated() {
        return !!this.LastZoningCodeVersion || !!this.calculationResultsCount;
    }

    get areCalculationResultsWithParams(): boolean {
        return this.CalculationResults.some(res => !!res.ZoningAllowanceId);
    }

    private initBuildings() {
        if (!this.Buildings) {
            return;
        }
        this.Buildings = this.Buildings.map(buildingData => new Building(buildingData));
    }
}

export function PropertyRecordFactory(data: IPropertyRecord) {
    return new PropertyRecord(data);
}
